import { axiosPost } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import setFormValidationError from 'shared/utils/setFormValidationError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  id: string | undefined
  setError: Function
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  props.data['filter_id'] = props.id
  props.data['is_default'] = 0

  const formData = {
    ...props.data,
    type: props.data?.type?.id ?? null
  }

  const catchFunc = (err: AxiosError) => {
    if (err.response!.status === 422) {
      setFormValidationError(err, props.setError, undefined, 'type')
    } else {
      displayGenError({ setShowOverlay: props.setShowOverlay })
    }
  }

  response = await axiosPost(apiUrls.filterValues, formData, catchFunc)
  return response
}

export default submitForm
